import React, { FC, createContext, useState } from 'react';

interface FilterContextType {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedFilter: string | undefined;
  setSelectedFilter: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const ValidationsFilterContext = createContext<FilterContextType>({
  isOpen: false,
  setIsOpen: () => undefined,
  selectedFilter: undefined,
  setSelectedFilter: () => undefined,
});

const ValidationsFilterProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedFilter, setSelectedFilter] = useState<string | undefined>(undefined);

  return (
    <ValidationsFilterContext.Provider
      value={{
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        selectedFilter: selectedFilter,
        setSelectedFilter: setSelectedFilter,
      }}
    >
      {children}
    </ValidationsFilterContext.Provider>
  );
};

export default ValidationsFilterProvider;
